export default "__VITE_ASSET__Cc94wlz1__"